/** This client's Nucleus tool-text vocabulary — see nucleus/tools/README.md.
 *
 *  Sent with every assistant call (chat + suggestions) as
 *  ui_context.tool_variables; core renders its tool placeholders with it, so
 *  sample prompts and routing text read in this client's own words. The JSON
 *  lives at the repo root, beside the other client-owned Nucleus setup, and is
 *  bundled at build time (vite: server.fs.allow covers the repo root in dev).
 */
import variables from "../../nucleus/tools/variables.json"

export const TOOL_VARIABLES: Readonly<Record<string, string>> = variables
